import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { IOrder } from '@redirector-service/shared';
import { MetaDataService } from '../metadata.service';
import { AsyncPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { HomeCarouselComponent } from '../home-carousel/home-carousel.component';
import { ImageModifierPipe } from '../image-modifer.pipe';
import { ReviewWriterComponent } from '../review-writer/review-writer.component';
import { OrderService } from '../order.service';

@Component({
    selector: 'tea-shop-fe-order',
    templateUrl: './order.component.html',
    styleUrl: './order.component.css',
    imports: [
    RouterLink,
    HomeCarouselComponent,
    AsyncPipe,
    CurrencyPipe,
    DatePipe,
    ImageModifierPipe,
    ReviewWriterComponent
]
})
export class OrderComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private metaDataService = inject(MetaDataService);
  private orderService = inject(OrderService);


  order?: IOrder;
  loading = true;
  error?: string;

  constructor() { 
    this.metaDataService.updateMetadata({
      title: 'Sencha Steep in Transit - Order Status',
      image: '/assets/contact/sencha-logo.png',
    });
  }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      if (data['order']) {
        this.order = data['order'];
        this.loading = false;
      } else {
        this.error = 'Order not found';
        this.loading = false;
      }
    });
  }

  onReviewSubmitted(): void {
    // Refresh the order data to get the updated review
    if (this.order?.id) {
      this.orderService.getOrder(this.order.id).subscribe({
        next: (updatedOrder) => {
          this.order = updatedOrder;
        },
        error: (error) => {
          console.error('Error refreshing order data:', error);
        }
      });
    }
  }

  getStatusStyle(status: string): string {
    const baseClasses = 'px-3 py-1 rounded-full text-sm font-medium';
    switch (status.toLowerCase()) {
      case 'pending':
      case 'created':
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case 'processing':
      case 'in transit':
        return `${baseClasses} bg-blue-100 text-blue-800`;
      case 'completed':
      case 'delivered':
        return `${baseClasses} bg-green-100 text-green-800`;
      case 'cancelled':
        return `${baseClasses} bg-red-100 text-red-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  }
}
